export enum DriversByDetectionType {
  Specific = 'SPECIFIC',
  Freelance = 'FREELANCE',
  Fleet = 'FLEET'
}
